import { render, staticRenderFns } from "./Website.vue?vue&type=template&id=6a916c78&scoped=true"
import script from "./Website.vue?vue&type=script&lang=js"
export * from "./Website.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/services.less?vue&type=style&index=0&id=6a916c78&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a916c78",
  null
  
)

export default component.exports